import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPinnedEvents as GetPinnedEventsQuery,
    GetPinnedEventsVariables as GetPinnedEventsQueryVariables,
    TimelineEventsPinnedInput,
} from 'nutshell-graphql-types';

import type {EventForTimeline} from '../../types';

import GET_PINNED_EVENTS from '../queries/get-pinned-events.graphql';

export const useGetPinnedEvents = (input: TimelineEventsPinnedInput) => {
    const {
        data,
        error,
        refetch,
        loading: isLoading,
    } = useQuery<GetPinnedEventsQuery, GetPinnedEventsQueryVariables>(GET_PINNED_EVENTS, {
        variables: {input},
        fetchPolicy: 'cache-and-network',
    });

    const pinnedEventsData = data ? data.pinnedEvents : undefined;

    const pinnedEvents: EventForTimeline[] = pinnedEventsData
        ? pinnedEventsData.edges.map((edge) => {
              return {...edge.node, pinnedInfo: edge.pinnedInfo};
          })
        : [];

    return {
        pinnedEvents: pinnedEvents ? pinnedEvents : [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        isLoading,
    };
};
